export default __webpack_public_path__ + "bc9121276096e4b7d848acb806c3990f.png";